import {VGLawCookie} from "vglawcookie";

let lastScrollTop = 0,
	$body = $('body');

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedHeader($(window));
		Vegas.grid();
		Vegas.clones();
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onResize: () => {
		Vegas.grid();
		Vegas.clones();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization", "color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	grid: function () {
		let $prd = $('.vg-shop-menu--prd:not(.compact)');

		if ($prd.length) {
			$prd.each(function () {
				$(this).css('height', $(this).find('.wrapper-area').height());
			});
		}
	},

	enablePlugins: function () {
		// navigation
		new VGNav({
			expand: 'lg',
			toggle: '<i class="fal fa-chevron-down"></i>'
		});

		//
		//$('.nice-select').niceSelect();

		// tooltip
		$('[data-bs-toggle="tooltip"]').tooltip();

		// select 2
		$('[data-toggle=select2]').each(function (i, e) {
			$(e).select2({
				language: 'ru',
				minimumResultsForSearch: $(e).data('search') ? 1 : -1,
			});
		});

		// sumo select
		$('[data-toggle=sumoselect]').each(function (i, e) {
			$(e).SumoSelect()
		});

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		VegasCarousel.init();
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default, .page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');

		setTimeout(() => {
			$('.vg-breadcrumbs').addClass('show');
		}, 500);
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.vg-header-wrapper'),
			scroll = $self.scrollTop(),
			scroll_offset = $sticky.height(),
			offset = $sticky.height();

		if (window.innerWidth < 820) {
			return false;
		}

		if (scroll > scroll_offset) {
			$body.addClass('vg-hdr--is-scroll');

			if (scroll > lastScrollTop) {
				$sticky.css('top', -offset);
				$body.removeClass('vg-hdr--is-fixed');
			} else {
				$sticky.addClass('fixed').css('top', 0);
				$body.addClass('vg-hdr--is-fixed');
			}

			lastScrollTop = scroll;
		} else {
			$sticky.removeClass('fixed').css('top', 0);
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}

		if ($body.hasClass('vg-hdr--is-fixed')) {
			$('.vg-shop-order--sticky').addClass('sticky');
			$('.vg-services-sticky').addClass('sticky');
			$('.vg-shop-sort').addClass('sticky');
		} else {
			$('.vg-services-sticky').removeClass('sticky');
			$('.vg-shop-sort').removeClass('sticky');
		}
	},

	clones: function () {
		if (window.innerWidth < 1199) {
			// Categories
			let $obj_categories_clone = $('.vg-shop-sidebar--categories');
			if ($obj_categories_clone.length) {
				$obj_categories_clone.clone().detach();
				$('.vg-categories-clone-area').append($obj_categories_clone)
			}
		}
		if (window.innerWidth < 820) {
			// Навигация
			let $obj_nav_clone = $('.vg-nav');
			if ($obj_nav_clone.length) {
				$obj_nav_clone.clone().detach();
				$('#vgnav-clone-area').append($obj_nav_clone);
			}
		}
	}
};
